"use strict";
/*
 * Describes standard functionality available in JSContexts
 *
 * Types are defined here to allow us to match the behavior available in JSContext in the target OS
 * which may not exactly match the definitions in standard TypeScript lib files, particularly on a
 * pre-release OS.
 *
 * The living standard for the Console API is available at https://console.spec.whatwg.org
 * The WebKit team has documented their interfaces at https://webkit.org/web-inspector/console-object-api/
 * The equivalent interface in Node is https://nodejs.org/api/console.html
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=console.js.map